import { render } from "./StoreConfirmationNumber.vue?vue&type=template&id=01afee21&scoped=true"
import script from "./StoreConfirmationNumber.vue?vue&type=script&lang=js"
export * from "./StoreConfirmationNumber.vue?vue&type=script&lang=js"

import "./StoreConfirmationNumber.vue?vue&type=style&index=0&id=01afee21&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-01afee21"

export default script